import { IOnchangeFieldHelper } from '../models/IOnchangeFieldHelper'

export const onChangeNumInput =
  ({ onChange }: IOnchangeFieldHelper<number>) =>
  (value: string) => {
    onChange(Number(value))
  }
